import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useCallback,
} from "react";
import right from "../../../assets/svg/right.svg";
import left from "../../../assets/svg/left.svg";
import gatein from "../../../assets/svg/gatein.svg";
import gateout from "../../../assets/svg/gateout.svg";
import dockin from "../../../assets/svg/dockin.svg";
import dockout from "../../../assets/svg/dockout.svg";
import queue from "../../../assets/svg/queue.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import downArrow from "../../../assets/svg/arrow-down.svg";
import mawalog from "../../../assets/svg/mawaloglogo.svg";
import Dasharrow from "../../../assets/svg/dasharrow.svg";
import DashWhitearrow from "../../../assets/svg/dashwhitearrow.svg";
import calendar from "../../../assets/svg/calendar.svg";
import search from "../../../assets/svg/search.svg";
import arrowDown from "../../../assets/svg/arrow-down-primary.svg";
import arrowUp from "../../../assets/svg/arrow-up-white.svg";

import {
  BarChart,
  Cell,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  LabelList,
} from "recharts";
import {
  fetchDaywiseInData,
  getAvailableDocksApi,
  getAverageDurationApi,
  getCountApi,
  getDaywiseAverageData,
  getDepartmentWiseData,
  getDepartmentWiseDockData,
  getHistoryCountApi,
  getLiveMonitorApi,
  getLocationFreeDocksApi,
  getLocationListApi,
  getTimingListApi,
  getVehicleWiseData,
  locationBasedDockOutDockInApi,
} from "./dashboard-api";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import "./Dashboard.css";
import { useGlobal } from "../../../GlobalContext";

const data = [
  { name: "Chennai", dockIn: 120, dockOut: 100, value: 187 },
  { name: "Pune", dockIn: 80, dockOut: 60, value: 175 },
  { name: "Mumbai", dockIn: 100, dockOut: 80, value: 137 },
  { name: "Delhi", dockIn: 30, dockOut: 20, value: 116 },
  { name: "Bengaluru", dockIn: 150, dockOut: 120, value: 104 },
  { name: "Kolkata", dockIn: 90, dockOut: 70 },
  { name: "Assam", dockIn: 130, dockOut: 100 },
];

const filteredData = data.filter((item) => item.value !== undefined);

const Custom2Tooltip = ({ active, payload, fontPercentage }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "hsla(0, 0.00%, 14.50%, 0.94)",
          border: "1px solid #ccc",
          color: "white",
          padding: 5,
          fontSize: fontResize(12, fontPercentage),
          boxShadow: "0px 2px 6px hsla(0, 1.20%, 32.90%, 0.81)",
        }}
      >
        <div>{`${payload[0]?.payload?.location} : ${payload[0].value}`}</div>
      </div>
    );
  }
  return null;
};

const CustomTooltip = ({ active, payload, label, fontPercentage }) => {
  if (
    active &&
    payload &&
    payload.length >= 2 &&
    payload[0]?.value !== undefined &&
    payload[1]?.value !== undefined
  ) {
    return (
      <div
        style={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "10px",
          boxShadow: "none",
          borderRadius: "5px",
          fontSize: `${fontResize(14, fontPercentage)}px`,
        }}
      >
        <p>{label}</p>
        <p>
          <span style={{ color: "#f66" }}>●</span> Gate In : {payload[0].value}
        </p>
        <p>
          <span style={{ color: "#fbb" }}>●</span> Dock In : {payload[1].value}
        </p>
      </div>
    );
  }
  return null;
};

const CustomInput = forwardRef(({ value, onClick, fontPercentage }, ref) => (
  <div
    onClick={onClick}
    ref={ref}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "10px 16px",
      borderRadius: "12px",
      border: "0.6px solid #E5E5E5",
      width: "fit-content",
      cursor: "pointer",
    }}
  >
    {/* <input
    onClick={onClick}
    ref={ref}
    value={`Since ${moment(value).format("DD MMM YYYY")}`}
    readOnly
    style={{ fontSize:'12px', fontWeight:'600', fontStyle:'SemiBold', color:'#D35258' }}
  /> */}
    <span
      style={{
        fontSize: `${fontResize(12, fontPercentage)}px`,
        fontWeight: "600",
        fontStyle: "SemiBold",
        color: "#D35258",
      }}
    >
      {value !== ""
        ? `Since ${moment(value).format("DD MMM YYYY")}`
        : "Select date"}
    </span>
    <img src={calendar} alt="calendar" />
  </div>
));

const DockWebDashboard = ({
  interval = 60,
  widgets = [
    /*  {
      id: 1,
      name: "Dock status list",
      seq_no: 1,
      status: true,
    },
    {
      id: 2,
      name: "Live count",
      seq_no: 2,
      status: true,
    },
    {
      id: 3,
      name: "History count",
      seq_no: 3,
      status: true,
    },
    {
      id: 4,
      name: "Location based dock in and out",
      seq_no: 4,
      status: true,
    },
    {
      id: 5,
      name: "Average duration",
      seq_no: 6,
      status: true,
    },
    {
      id: 6,
      name: "Location based free docks",
      seq_no: 5,
      status: true,
    },
    {
      id: 7,
      name: "Timings",
      seq_no: 7,
      status: true,
    },
    {
      id: 8,
      name: "Day wise gate and dock in",
      seq_no: 8,
      status: true,
    },
    {
      id: 9,
      name: "Day wise average duration",
      seq_no: 9,
      status: true,
    },
    {
      id: 10,
      name: "Vehicle came in and out",
      seq_no: 10,
      status: true,
    },
    {
      id: 11,
      name: "Department wise dock overview",
      seq_no: 11,
      status: true,
    },
    {
      id: 12,
      name: "Live monitor",
      seq_no: 12,
      status: true,
    }, */
  ],
}) => {
  let { dashboardToken } = useGlobal();
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    dashboardToken =
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS11YXQubWF3YWxvZy5jb20vc2lnbmFnZS92MS9hcGkvZGV2aWNlLzY3IiwiaWF0IjoxNzY3MTM5MTk5LCJleHAiOjE3OTg2NzUxOTksIm5iZiI6MTc2NzEzOTE5OSwianRpIjoiTGtBTU5qdHhCanFxNFBhRSIsInN1YiI6IjY3IiwicHJ2IjoiYjkwZjcxZjJiMDQ2ZjM1NDJhMDI3ODEwODllYTc1NjY4ZmUzYWU2MyIsImF1dGhpZCI6MTIzMiwib3JnaWQiOjEwNSwidXNlcmlkIjoxMjMyLCJkYXRhYmFzZW5hbWUiOiJyYWd1cnIiLCJvcmdfY29kZSI6InJhZ3VyciIsInRpbWV6b25lIjoiIiwicm9sZWlkIjo0OTcsInBheW1lbnRfc3RhdHVzIjp0cnVlLCJhdXRob3JpdGllcyI6WyJST0xFX1VTRVIiXSwiZGV2aWNlSWQiOjY3LCJncm91cElkIjo1Miwic2lnbmFnZV9jb2RlIjoiIn0.VpzQxFgAA2lqyRoIrKp9kkOiAg6j1-k7sfYQj9VO-4A";
  }
  const [selectedTopBar, setSelectedTopBar] = useState("transporter");
  const [selectedSideBar, setSelectedSideBar] = useState("vehicletype");
  const [searchVehicleInOut, setSearchVehicleInOut] = useState("vehicletype");
  const [vehicleTransType, setVehicleTransType] = useState("in");

  const [sortedWidgetList, setSortedWidgetList] = useState([]);
  useEffect(() => {
    setSortedWidgetList([...widgets].sort((a, b) => a.seq_no - b.seq_no));
  }, [widgets]);

  const scrollRef = useRef(null);
  const handleScroll = (dir) => {
    const scrollAmount = 200;
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: dir === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };
  /*  const details = Array(3).fill({
        vehicleNumber: "TN 08 AV 5645",
        time: "01:45 PM",
        dockno: "L2",
        Timer: "00:38:12",
      }); */
  const [startFromDate, setStartFromDate] = useState("");
  const [availableDockList, setAvailableDockList] = useState([]);
  const [dockCount, setDockCount] = useState();
  const [dockHistoryCount, setDockHistoryCount] = useState();
  const [liveMonitorList, setLiveMonitorList] = useState([]);
  const [timingList, setTimingList] = useState([]);
  const [locationBasedInAndOut, setLocationBasedInAndOut] = useState([]);
  const [freeDocks, setFreeDocks] = useState();
  const [locationDIDOCount, setLocationDIDOCount] = useState(null);
  const [selectedduration, setSelectedduration] = useState("gateIn_gateOut");

  const searchInputRef = useRef();
  const [searchText, setSearchText] = useState("");
  const [expandIndex, setExpandIndex] = useState(-1);

  const percentage = 43;
  const totalSegments = 30;
  const activeSegments = Math.round(
    ((freeDocks?.dock_percentage ?? 0) / 100) * totalSegments
  );

  const segments = Array.from({ length: totalSegments }, (_, i) => {
    const rotation = (i / totalSegments) * 180 - 90;
    const isActive = i < activeSegments;

    return (
      <rect
        key={i}
        x="-2"
        y="-90"
        width="4"
        height="20"
        fill={isActive ? "#eb4d4b" : "#eee"}
        transform={`rotate(${rotation})`}
        rx="2"
      />
    );
  });

  const [selected, setSelected] = useState(null); // no default selection
  const pickerRef = useRef();

  const handleClick = () => {
    pickerRef.current.show();
  };

  const handleChange = (year, month) => {
    setSelected({ year, month });
    console.log(`${String(month).padStart(2, "0")}${year}`);
  };

  const pickerLang = {
    months: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  };

  const CircleLabel = (props, fontPercentage) => {
    console.log(props);
    const { x, y, width, value, height, index } = props;
    console.log({ x, y, width, value, height, index });
    if (x == null || y == null) return null;
    const radius = 14;
    const padding = 10;
    const textX = x + padding;
    const textY = y + height / 2 + 1;
    const cx = x + width - radius - 4; // padding from right
    const cy = y + height / 2;
    const location = freeDocks?.docks[index].location;

    return (
      <g key={`location${index}`}>
        <foreignObject x={textX} y={textY - 20} width={width - 40} height={42}>
          <div
            fill="#172B4D"
            dominantBaseline="middle"
            style={{
              width: `${width - 40}px`,
              height: "36px",
              display: "flex",
              alignItems: "center",
              fontSize: `${fontResize(14, fontPercentage)}px`,
              fontFamily: "Epilogue",
              fontWeight: "400",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {location}
          </div>
        </foreignObject>
        <circle cx={cx} cy={cy} r={radius} fill="#fff" />
        <text
          x={cx}
          y={cy}
          textAnchor="middle"
          fontFamily="Epilogue"
          dominantBaseline="central"
          fill="#D35258"
          fontSize="13"
          fontWeight="600"
        >
          {value}
        </text>
      </g>
    );
  };

  useEffect(() => {
    if (startFromDate !== "") {
      getHistoryCount(moment(startFromDate).format("YYYY-MM-DD"));
    }
  }, [startFromDate]);

  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const alertDatePicTotalBookingRef = useRef(null);
  useEffect(() => {
    if (selectedMonth != null) {
      locationBasedDockOutDockIn();
    }
  }, [selectedMonth]);

  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDatePicker);
    };
  }, []);

  const handleCloseDatePicker = (event) => {
    if (
      alertDatePicTotalBookingRef.current &&
      !alertDatePicTotalBookingRef.current.contains(event.target)
    ) {
      setShowMonthPicker(false);
    }
  };
  const handleMonthPickerChange = (date) => {
    console.log("handleDateChange.......", date);
    if (date !== undefined) {
      setSelectedMonth(date);
      setShowMonthPicker(false);
    }

    console.log("fetchOptions called from handleDateChange", date);
  };

  const [showVehicleMonthPicker, setShowVehicleMonthPicker] = useState(false);
  const [selectedVehicleMonth, setSelectedVehicleMonth] = useState(null);
  const alertVehicleDateRef = useRef(null);
  const handleVehicleMonthPickerChange = (date) => {
    console.log("handleDateChange.......", date);
    if (date !== undefined) {
      setSelectedVehicleMonth(date);
      setShowVehicleMonthPicker(false);
    }

    console.log("fetchOptions called from handleDateChange", date);
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseVehicleDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseVehicleDatePicker);
    };
  }, []);
  const handleCloseVehicleDatePicker = (event) => {
    if (
      alertVehicleDateRef.current &&
      !alertVehicleDateRef.current.contains(event.target)
    ) {
      setShowVehicleMonthPicker(false);
    }
  };

  const [showDeptMonthPicker, setShowDeptMonthPicker] = useState(false);
  const [selectedDeptMonth, setSelectedDeptMonth] = useState(null);
  const alertDeptDateRef = useRef(null);
  const handleDeptMonthPickerChange = (date) => {
    if (date !== undefined) {
      setSelectedDeptMonth(date);
      setShowDeptMonthPicker(false);
    }
  };
  useEffect(() => {
    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDeptDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDeptDatePicker);
    };
  }, []);
  const handleCloseDeptDatePicker = (event) => {
    if (
      alertDeptDateRef.current &&
      !alertDeptDateRef.current.contains(event.target)
    ) {
      setShowDeptMonthPicker(false);
    }
  };
  useEffect(() => {
    getAvailableDocks();
    getCount();

    getLocationFreeDocks();
    getTimingList();
    getMonitorList();
    setSelectedMonth(new Date());
    setSelectedDeptMonth(new Date());
    setSelectedVehicleMonth(new Date());
    getHistoryCount("");
  }, []);

  const intervalRef = useRef(null);

  const callAllAPIs = () => {
    const apiMap = {
      "Dock status list": getAvailableDocks,
      "Live count": getCount,
      "History count": () => getHistoryCount(""),
      "Location based free docks": getLocationFreeDocks,
      Timings: getTimingList,
      "Live monitor": getMonitorList,
      "Location based dock in and out":
        selectedMonth != null ? locationBasedDockOutDockIn : null,
      "Department wise dock overview":
        selectedDeptMonth != null ? fetchDepartmentWiseData : null,
      "Vehicle came in and out":
        selectedVehicleMonth != null ? fetchVehicleWiseData : null,
    };

    sortedWidgetList.forEach((widget) => {
      if (widget.status && apiMap[widget.name]) {
        apiMap[widget.name]();
      }
    });
  };

  useEffect(() => {
    console.log("interval init");
    // Initial API call
    callAllAPIs();

    // Setup interval
    intervalRef.current = setInterval(() => {
      console.log("interval loop");
      callAllAPIs();
    }, interval * 1000); // convert seconds to ms

    // Cleanup on unmount
    return () => clearInterval(intervalRef.current);
  }, [
    interval,
    sortedWidgetList,
    selectedMonth,
    selectedDeptMonth,
    selectedVehicleMonth,
  ]);

  const getAvailableDocks = async () => {
    try {
      const response = await getAvailableDocksApi(dashboardToken);
      if (response.data.success === true) {
        setAvailableDockList(response.data.docks);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getCount = async () => {
    try {
      const response = await getCountApi(dashboardToken);
      if (response.data.success === true) {
        setDockCount(response.data.count);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getHistoryCount = async (date) => {
    try {
      const response = await getHistoryCountApi(date, dashboardToken);
      if (response.data.success === true) {
        setDockHistoryCount(response.data.count);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getLocationFreeDocks = async () => {
    try {
      const response = await getLocationFreeDocksApi(dashboardToken);
      if (response.data.success === true) {
        setFreeDocks(response.data.data);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getTimingList = async () => {
    try {
      const response = await getTimingListApi(dashboardToken);
      if (response.data.success === true) {
        setTimingList(response.data.timings);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getMonitorList = async () => {
    try {
      const response = await getLiveMonitorApi(dashboardToken);
      if (response.data.success === true) {
        setLiveMonitorList(response.data.docks);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const locationBasedDockOutDockIn = async () => {
    try {
      const response = await locationBasedDockOutDockInApi(
        formatDateCommon(selectedMonth != null ? selectedMonth : "", "MM-YYYY"),
        dashboardToken
      );
      if (response.data.success === true) {
        setLocationDIDOCount(response.data.count);
        setLocationBasedInAndOut(response.data.data);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  function formatDateCommon(inputDate, formatType) {
    try {
      if (inputDate !== undefined && inputDate !== null && inputDate !== "") {
        // Parse the input date (MM/DD/YYYY format)
        /*  const parsedDate = parse(inputDate, 'MM/dd/yyyy', new Date());
       
         // Format the date
         return format(parsedDate, formatType); */
        return moment(inputDate).format(formatType);
      } else {
        return "";
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    } finally {
    }
  }

  const [averageMonthDate, setAverageMonthDate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  });
  const apiUrl = process.env.REACT_APP_API_URL;
  const [showAveragePicker, setShowAveragePicker] = useState(false);
  const [averageData, setAverageData] = useState(null);
  const [loadingAverage, setLoadingAverage] = useState(false);
  const [averageError, setAverageError] = useState(null);

  const averagePickerTriggerRef = useRef(null);
  const averagePickerCalendarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        averagePickerCalendarRef.current &&
        !averagePickerCalendarRef.current.contains(event.target) &&
        !averagePickerTriggerRef.current.contains(event.target)
      ) {
        setShowAveragePicker(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    fetchAverageData(averageMonthDate);
  }, []);

  const fetchAverageData = async (month) => {
    setLoadingAverage(true);
    setAverageError(null);
    try {
      const response = await getAverageDurationApi(
        { period: month },
        dashboardToken
      );
      if (response?.data?.success) {
        setAverageData(response.data.average);
      } else {
        setAverageError("Data not found");
      }
    } catch (err) {
      setAverageError("Something went wrong");
    } finally {
      setLoadingAverage(false);
    }
  };

  const formatAverageDate = (date, format) => {
    const options = { month: "short", year: "numeric" };
    const d = new Date(date);
    return format === "MMM, YYYY"
      ? d.toLocaleDateString("en-US", options)
      : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
  };

  const handleMonthChange = (date) => {
    const formatted = formatAverageDate(date, "yyyy-MM");
    setAverageMonthDate(formatted);
    setShowAveragePicker(false);
    fetchAverageData(formatted);
  };

  //Day wise count

  const [daywiseMonthDate, setDaywiseMonthDate] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(
      2,
      "0"
    )}`;
  });
  const [showDaywiseMonthPicker, setShowDaywiseMonthPicker] = useState(false);

  const daywisePickerTriggerRef = useRef(null);
  const daywisePickerCalendarRef = useRef(null);

  const [daywiseData, setDaywiseData] = useState([]);
  const [daywisePercentage, setDaywisePercentage] = useState("");
  const [daywiseIsLow, setDaywiseIsLow] = useState("");

  const [loadingDaywise, setLoadingDaywise] = useState(false);
  const [errorDaywise, setErrorDaywise] = useState(null);

  // Call this function to get API data
  const getDaywiseData = async (month) => {
    setLoadingDaywise(true);
    setErrorDaywise(null);
    try {
      const res = await fetchDaywiseInData(month, dashboardToken); // <-- Make sure this function is imported
      if (res?.data?.success) {
        const formatted = res.data.data?.daywise.map((item) => ({
          day: `Day ${item.day}`,
          gatein: item.gatein,
          dockin: item.dockin,
        }));
        setDaywiseData(formatted);
        setDaywisePercentage(res.data.data?.percent);
        setDaywiseIsLow(res.data.data?.is_low);
      } else {
        setErrorDaywise(res?.data?.message || "No data found");
      }
    } catch (error) {
      setErrorDaywise("Error fetching data");
    }
    setLoadingDaywise(false);
  };

  const handleDaywiseMonthChange = (date) => {
    const formatted = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}`;
    setDaywiseMonthDate(formatted);
    setShowDaywiseMonthPicker(false);
    getDaywiseData(formatted);
  };

  // Auto-fetch data on load
  useEffect(() => {
    getDaywiseData(daywiseMonthDate);
  }, []);

  // Hide picker on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        daywisePickerCalendarRef.current &&
        !daywisePickerCalendarRef.current.contains(event.target) &&
        !daywisePickerTriggerRef.current.contains(event.target)
      ) {
        setShowDaywiseMonthPicker(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //Day wise average

  const [dayWiseAverageMonth, setDayWiseAverageMonth] = useState(new Date());
  const [showDayWiseAveragePicker, setShowDayWiseAveragePicker] =
    useState(false);
  const [selectedDayWiseAverageType, setSelectedDayWiseAverageType] =
    useState("gatein_out");
  const [dayWiseAverageChartData, setDayWiseAverageChartData] = useState([]);
  const dayWiseAveragePickerRef = useRef(null);

  const handleDayWiseAverageMonthChange = (date) => {
    setDayWiseAverageMonth(date);
    setShowDayWiseAveragePicker(false);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dayWiseAveragePickerRef.current &&
        !dayWiseAveragePickerRef.current.contains(event.target)
      ) {
        setShowDayWiseAveragePicker(false);
      }
    };

    if (showDayWiseAveragePicker) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showDayWiseAveragePicker]);

  useEffect(() => {
    const fetchAverageData = async () => {
      const period = `${dayWiseAverageMonth.getFullYear()}-${String(
        dayWiseAverageMonth.getMonth() + 1
      ).padStart(2, "0")}`;
      const payload = { period, type: selectedDayWiseAverageType };

      try {
        const data = await getDaywiseAverageData(payload, dashboardToken);
        const formatted = data.map((item) => ({
          day: `Day ${item.day}`,
          avg: parseInt(item.avg),
        }));
        setDayWiseAverageChartData(formatted);
      } catch (error) {
        console.error("Error fetching day-wise average data:", error);
        setDayWiseAverageChartData([]);
      }
    };

    fetchAverageData();
  }, [dayWiseAverageMonth, selectedDayWiseAverageType]);

  //LOcation

  const [locations, setLocations] = useState([]);
  const [selectedLocationId, setSelectedLocationId] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const list = await getLocationListApi(dashboardToken);
      setLocations(list);
    };
    fetchData();
  }, []);

  const handleLocationChange = (e) => {
    const selectedId = e.target.value;
    setSelectedLocationId(selectedId);
    console.log("Selected Location ID:", selectedId);
  };

  const [vehicleInOutCount, setVehicleInOutCount] = useState([]);

  useEffect(() => {
    if (selectedVehicleMonth != null) {
      fetchVehicleWiseData();
    }
  }, [
    selectedSideBar,
    selectedTopBar,
    searchVehicleInOut,
    vehicleTransType,
    selectedVehicleMonth,
  ]);

  const handleSearch = useCallback((event) => {
    const delayDebounce = setTimeout(() => {
      fetchVehicleWiseData();
    }, 500); // delay API call by 500ms

    return () => clearTimeout(delayDebounce);
  }, []);

  const fetchVehicleWiseData = async () => {
    const period = `${selectedVehicleMonth.getFullYear()}-${String(
      selectedVehicleMonth.getMonth() + 1
    ).padStart(2, "0")}`;
    const payload = {
      period: period,
      type: vehicleTransType,
      search_type: searchVehicleInOut,
      search: searchInputRef?.current?.value,
      top_bar: selectedTopBar,
      side_bar: selectedSideBar,
    };

    try {
      const data = await getVehicleWiseData(payload, dashboardToken);

      setVehicleInOutCount(data ?? []);
    } catch (error) {
      console.error("Error fetching day-wise average data:", error);
      setVehicleInOutCount([]);
    }
  };

  const [departmentWiseData, setDepartmentWiseData] = useState([]);
  useEffect(() => {
    if (selectedDeptMonth != null) {
      fetchDepartmentWiseData();
    }
  }, [selectedLocationId, selectedDeptMonth]);

  const fetchDepartmentWiseData = async () => {
    const period = `${selectedDeptMonth.getFullYear()}-${String(
      selectedDeptMonth.getMonth() + 1
    ).padStart(2, "0")}`;
    const payload = {
      period: period ?? "",
      location_id: selectedLocationId ?? "",
    };

    try {
      const data = await getDepartmentWiseData(payload, dashboardToken);

      setDepartmentWiseData(data ?? []);
    } catch (error) {
      console.error("Error fetching day-wise average data:", error);
      setDepartmentWiseData([]);
    }
  };

  const [departmentWiseDockData, setDepartmentWiseDockData] = useState([]);
  const fetchDepartmentWiseDockData = async (department_id) => {
    const period = `${selectedDeptMonth.getFullYear()}-${String(
      selectedDeptMonth.getMonth() + 1
    ).padStart(2, "0")}`;
    const payload = {
      period: period,
      location_id: selectedLocationId,
      department_id: department_id,
    };

    try {
      const data = await getDepartmentWiseDockData(payload, dashboardToken);

      setDepartmentWiseDockData(data ?? []);
    } catch (error) {
      console.error("Error fetching day-wise average data:", error);
      setDepartmentWiseDockData([]);
    }
  };

  const fontResize = (baseFont, percentage) => {
    const fontSize = baseFont * (1 + percentage / 100);
    return fontSize;
  };

  const dockStatusWidget = (fontPercentage) => {
    return (
      <div className="d_series">
        <button
          type="button"
          className="d_sers_btn"
          onClick={() => handleScroll("left")}
        >
          <img src={left} alt="left" srcSet="" />
        </button>

        <span className="scroller" ref={scrollRef}>
          {availableDockList.map((item, index) => (
            <div
              className={`${
                item.available_status === true ? "available_box" : ""
              } ${
                item.available_status === false &&
                item.current_status === "ontime"
                  ? "on_time_box"
                  : ""
              } ${
                item.available_status === false &&
                item.current_status === "delay"
                  ? "delay_box"
                  : ""
              } ${
                item.available_status === false &&
                item.current_status === "overdelay"
                  ? "over_delay_box"
                  : ""
              }`}
              key={"avail_dock" + index}
            >
              <div>
                <div
                  className={`${
                    item.available_status === true ? "available_text_1" : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "ontime"
                      ? "on_time_text_1"
                      : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "delay"
                      ? "delay_text_1"
                      : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "overdelay"
                      ? "over_delay_text_1"
                      : ""
                  }`}
                  style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                >
                  {item.display_name}
                </div>

                <div
                  className={`${
                    item.available_status === true ? "available_text_2" : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "ontime"
                      ? "on_time_text_2"
                      : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "delay"
                      ? "delay_text_2"
                      : ""
                  } ${
                    item.available_status === false &&
                    item.current_status === "overdelay"
                      ? "over_delay_text_2"
                      : ""
                  }`}
                  style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                >
                  {item.available_status ? "Available" : ""}
                  {item.available_status === false && (
                    <div style={{ minWidth: "50px" }}>
                      {item.duration != null && (
                        <Timer
                          key={"overdelay_timer" + index}
                          fontPercentage={fontPercentage}
                          initialSeconds={parseDuration(item.duration)}
                        />
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </span>

        <button
          type="button"
          className="d_sers_btn"
          onClick={() => handleScroll("right")}
        >
          <img src={right} alt="right" srcSet="" />
        </button>
      </div>
    );
  };
  const liveCountWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={6} className="mt-3">
        <div className="container_box col">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ minHeight: "36px" }}
          >
            <div
              className="font_16_700_172B4D"
              style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
            >
              Live count
            </div>
          </div>
          <Row className="box_contain row d-flex">
            <Col sm={12} md={3} className="mt-2 px-1">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={gatein} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    Gate In
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockCount?.gate_in ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>

            <Col sm={12} md={3} className="mt-2 px-1">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={queue} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    In Queue
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockCount?.in_queue ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>

            <Col sm={12} md={3} className="mt-2 px-1">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={dockin} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    Dock In
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockCount?.dock_in ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>

            <Col sm={12} md={3} className="mt-2 px-1">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={queue} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    Out Queue
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockCount?.out_queue ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    );
  };
  const historyCountWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={6} className="mt-3">
        <div className="container_box col">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ height: "36px" }}
          >
            <div
              className="font_16_700_172B4D"
              style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}
            >
              History
            </div>
            <div>
              <DatePicker
                selected={startFromDate}
                onChange={(date) => setStartFromDate(date)}
                customInput={<CustomInput fontPercentage={fontPercentage} />}
              />
              {/*   <DatePicker
      selected={startFromDate}
      onChange={(date) => setStartFromDate(date)}
      customInput={
        <input
          value={(date) => {
    return `Since ${moment(date).format("DD MMM YYYY")}`;
  }}
          onClick={(e) => e.target.select()}
          readOnly
        />
      }
    /> */}
            </div>
          </div>
          <Row>
            <Col className=" text-center mt-2">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={gatein} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    Gate In
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockHistoryCount?.gate_in ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col className=" text-center mt-2">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={dockin} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    Dock In
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockHistoryCount?.dock_in ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col className=" text-center mt-2">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={dockout} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    Dock Out
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockHistoryCount?.dock_out ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col className=" text-center mt-2">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={gateout} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    Gate Out
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockHistoryCount?.gate_out ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
            <Col className=" text-center mt-2">
              <div className="boxses col">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="box_icon">
                    <img src={queue} alt="" />
                  </div>
                </div>
                <div className="box_text">
                  <p
                    style={{ fontSize: `${fontResize(13, fontPercentage)}px` }}
                  >
                    Not Handled
                  </p>
                  <div className="gap-3">
                    <span
                      style={{
                        color: "#172B4D",
                        fontSize: `${fontResize(30, fontPercentage)}px`,
                        fontWeight: "700",
                      }}
                    >
                      {dockHistoryCount?.not_handled ?? "0"}
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
    );
  };

  const locationDockInOutWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={6} className="mt-3">
        <div className="chart_left col">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ height: "36px" }}
          >
            <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
              Location based dock in & dock out
            </h3>
            <div
              onClick={() => setShowMonthPicker(true)}
              style={{
                position: "relative",
                width: "146px",
                height: "36px",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#842234",
                }}
              >
                {formatDateCommon(
                  selectedMonth != null ? selectedMonth : undefined,
                  "MMM, YYYY"
                )}{" "}
                &nbsp; <img src={downArrow} />
              </div>
              {showMonthPicker && (
                <div
                  ref={alertDatePicTotalBookingRef}
                  style={{
                    position: "absolute",
                    top: "40px",
                    right: "0",
                    zIndex: 100,
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <Calendar
                    onChange={handleMonthPickerChange}
                    value={selectedMonth}
                    view="year"
                    onClickMonth={(date) => handleMonthPickerChange(date)}
                  />
                </div>
              )}
            </div>
          </div>

          <div
            className="d-flex gap-3"
            style={{ width: "240px", height: "32px" }}
          >
            <span
              style={{
                color: locationDIDOCount?.is_low ? "#3D9D85" : "#fbb",
                fontSize: `${fontResize(30, fontPercentage)}px`,
                fontWeight: "700",
              }}
            >
              {locationDIDOCount?.percent ?? "0"}%
            </span>
            <label
              htmlFor=""
              style={{
                color: "#66737E",
                fontFamily: "Epilogue",
                fontWeight: "400",
                fontSize: `${fontResize(13, fontPercentage)}px`,
              }}
            >
              {locationDIDOCount?.is_low ? "increased" : "decreased"} from last
              month
            </label>
          </div>

          <div style={{ width: "100%", overflowX: "auto" }}>
            <BarChart
              data={locationBasedInAndOut ?? []}
              barSize={12}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              width={700}
              height={220}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis
                dataKey="location"
                tickFormatter={(value) =>
                  value.length > 10 ? value.substring(0, 10) + "…" : value
                }
              />
              <Tooltip
                content={<CustomTooltip fontPercentage={fontPercentage} />}
                cursor={{ fill: "transparent" }}
              />
              <Bar
                dataKey="in_count"
                fill="#f66"
                radius={[10, 10, 0, 0]}
                activeBar={false}
              />
              <Bar
                dataKey="out_count"
                fill="#fbb"
                radius={[10, 10, 0, 0]}
                activeBar={false}
              />
            </BarChart>
          </div>
        </div>
      </Col>
    );
  };
  const locationFreeDocksWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={6} className="mt-3">
        <div className="chart_right col">
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ height: "36px" }}
          >
            <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
              Location based free docks
            </h3>
          </div>

          <div className="d-flex row">
            <div className="col-5">
              <div
                className="flex items-center justify-center"
                style={{ width: "100%", height: "148px" }}
              >
                <svg width="100%" height="100%" viewBox="0 0 200 120">
                  <g transform="translate(100,100)">{segments}</g>
                  <text
                    x="100"
                    y="80"
                    textAnchor="middle"
                    fontSize={`${fontResize(28, fontPercentage)}px`}
                    fontWeight="500"
                    fill="#172B4D"
                  >
                    {freeDocks?.dock_percentage ?? "0"}%
                  </text>
                  <text
                    x="100"
                    y="100"
                    textAnchor="middle"
                    fontSize={`${fontResize(12, fontPercentage)}px`}
                    fill="#626F86"
                    fontFamily="Epilogue"
                    fontWeight={400}
                  >
                    of docks are free now
                  </text>
                </svg>
              </div>

              <div
                className="d-flex flex-column"
                style={{
                  backgroundColor: "#F9F9F9",
                  padding: "15px",
                  borderRadius: "10px",
                }}
              >
                <div className="d-flex gap-1">
                  <div
                    style={{
                      height: "12px",
                      width: "12px",
                      borderRadius: "50px",
                      backgroundColor: "#D35258",
                      marginTop: "3px",
                    }}
                  ></div>
                  <div
                    className="live_text"
                    style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                  >
                    Free docks
                  </div>
                </div>
                <div
                  style={{
                    color: "#172B4D",
                    fontSize: `${fontResize(30, fontPercentage)}px`,
                    fontWeight: "700",
                  }}
                >
                  {freeDocks?.count ?? "0"}
                </div>
              </div>
            </div>

            <div
              className="col"
              style={{
                height: "270px",
                margin: 0,
                padding: 0,
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                <BarChart
                  layout="vertical"
                  data={freeDocks?.docks}
                  margin={{ top: 20, right: 0, left: 0, bottom: 5 }}
                >
                  <XAxis type="number" hide />
                  <YAxis
                    type="category"
                    dataKey="location"
                    axisLine={{ stroke: "pink", strokeWidth: 3 }}
                    tick={false}
                    width={0}
                  />
                  <Tooltip
                    content={<Custom2Tooltip fontPercentage={fontPercentage} />}
                    cursor={{ fill: "transparent" }}
                  />
                  <Bar
                    dataKey="count"
                    fill="#ffe6e6"
                    radius={[0, 15, 15, 0]}
                    barSize={36}
                  >
                    <LabelList
                      dataKey="count"
                      content={<CircleLabel fontPercentage={fontPercentage} />}
                    />
                    {freeDocks?.docks.map((entry, index) => (
                      <Cell key={`freecell-${index}`} fill="#ffe6e6" />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>
      </Col>
    );
  };

  const averageDurationWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={6} lg={8} className="mt-3">
        <div
          style={{
            borderRadius: "16px",
            padding: "16px",
            backgroundColor: "#ffffff",
            height: "fit-content",
            overflowY: "auto",
          }}
        >
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ height: "36px", position: "relative" }}
          >
            <h3
              style={{
                fontWeight: "700",
                fontSize: `${fontResize(16, fontPercentage)}px`,
                color: "#172b4d",
                marginBottom: "0",
              }}
            >
              Average duration
            </h3>
            <div
              ref={averagePickerTriggerRef}
              onClick={() => setShowAveragePicker(true)}
              style={{
                position: "relative",
                width: "146px",
                height: "36px",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#842234",
                }}
              >
                {averageMonthDate
                  ? formatAverageDate(averageMonthDate, "MMM, YYYY")
                  : "Select Month"}{" "}
                &nbsp;
                <img src={downArrow} />
              </div>
            </div>
          </div>

          {showAveragePicker && (
            <div
              ref={averagePickerCalendarRef}
              style={{
                position: "absolute",
                top: "76px",
                right: "16px",
                zIndex: 100,
                background: "#fff",
                border: "1px solid #ccc",
                borderRadius: "4px",
                boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
              }}
            >
              <Calendar
                onChange={handleMonthChange}
                value={
                  averageMonthDate
                    ? new Date(averageMonthDate + "-01")
                    : new Date()
                }
                view="year"
                onClickMonth={handleMonthChange}
              />
            </div>
          )}

          {loadingAverage ? (
            <div className="mt-3">Loading...</div>
          ) : averageData ? (
            <Row className="mt-3">
              <Col sm={12} md={12} lg={4} xl={3} className="mb-3">
                <div
                  style={{
                    backgroundColor: "#f8f8f8",
                    borderRadius: "16px",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "16px",
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      Gate in
                    </div>
                    <img src={Dasharrow} style={{ height: "10px" }} />
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      Gate out
                    </div>
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "24px",
                      color: "#172b4d",
                    }}
                  >
                    {averageData.gatein_out}{" "}
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: `${fontResize(16, fontPercentage)}px`,
                      }}
                    >
                      mins
                    </span>
                  </div>
                </div>
              </Col>
              <Col sm={12} md={12} lg={4} xl={3} className="mb-3">
                <div
                  style={{
                    backgroundColor: "#f8f8f8",
                    borderRadius: "16px",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "16px",
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      Dock in
                    </div>
                    <img src={Dasharrow} style={{ height: "10px" }} />
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      Dock out
                    </div>
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "24px",
                      color: "#172b4d",
                    }}
                  >
                    {averageData.dockin_out}{" "}
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: `${fontResize(16, fontPercentage)}px`,
                      }}
                    >
                      mins
                    </span>
                  </div>
                </div>
              </Col>
              <Col sm={12} md={12} lg={4} xl={3} className="mb-3">
                <div
                  style={{
                    backgroundColor: "#f8f8f8",
                    borderRadius: "16px",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "16px",
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      Gate in
                    </div>
                    <img src={Dasharrow} style={{ height: "10px" }} />
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      Dock in
                    </div>
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "24px",
                      color: "#172b4d",
                    }}
                  >
                    {averageData.gatein_dockin}{" "}
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: `${fontResize(16, fontPercentage)}px`,
                      }}
                    >
                      mins
                    </span>
                  </div>
                </div>
              </Col>
              <Col sm={12} md={12} lg={4} xl={3} className="mb-3">
                <div
                  style={{
                    backgroundColor: "#f8f8f8",
                    borderRadius: "16px",
                    padding: "16px",
                  }}
                >
                  <div
                    style={{
                      marginBottom: "16px",
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      Dock out
                    </div>
                    <img src={Dasharrow} style={{ height: "10px" }} />
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      Gate out
                    </div>
                  </div>
                  <div
                    style={{
                      fontWeight: "700",
                      fontSize: "24px",
                      color: "#172b4d",
                    }}
                  >
                    {averageData.dockout_gateout}{" "}
                    <span
                      style={{
                        fontWeight: "500",
                        fontSize: `${fontResize(16, fontPercentage)}px`,
                      }}
                    >
                      mins
                    </span>
                  </div>
                </div>
              </Col>
            </Row>
          ) : averageError ? (
            <div className="mt-3 text-danger">{averageError}</div>
          ) : null}
        </div>
      </Col>
    );
  };
  const timingsWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={6} lg={4} className="mt-3">
        <div
          style={{
            borderRadius: "16px",
            padding: "16px",
            backgroundColor: "#ffffff",
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              fontWeight: "700",
              fontSize: `${fontResize(16, fontPercentage)}px`,
              color: "#172b4d",
              marginBottom: "16px",
            }}
          >
            Timings :
          </div>
          <Row>
            {timingList.map((timing, index) => (
              <Col sm={12} md={12} lg={6} xl={6} className="mb-3" key={index}>
                <div
                  style={{
                    borderRadius: "16px",
                    border: "0.6px solid #e5e5e5",
                    padding: "12px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: "500",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#172b4d",
                      }}
                    >
                      {timing.name ?? "N/A"}
                    </div>
                    <div
                      style={{
                        fontWeight: "600",
                        fontSize: `${fontResize(16, fontPercentage)}px`,
                        color: "#d35258",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      {timing.loadintime ?? "--:--"}
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Col>
    );
  };
  const dayWiseGateDockInWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={6} className="mt-3">
        <div className="chart_left col" style={{ height: "100%" }}>
          {/* Header with Month Picker */}
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ height: "36px" }}
          >
            <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
              Day wise Gate In & Dock In
            </h3>
            <div
              onClick={() => setShowDaywiseMonthPicker(true)}
              ref={daywisePickerTriggerRef}
              style={{
                position: "relative",
                width: "146px",
                height: "36px",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#842234",
                }}
              >
                {daywiseMonthDate
                  ? formatDateCommon(daywiseMonthDate, "MMM, YYYY")
                  : "Select Month"}{" "}
                &nbsp;
                <img src={downArrow} />
              </div>
              {showDaywiseMonthPicker && (
                <div
                  ref={daywisePickerCalendarRef}
                  style={{
                    position: "absolute",
                    top: "40px",
                    right: "0",
                    zIndex: 100,
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <Calendar
                    onChange={(date) => handleDaywiseMonthChange(date)}
                    value={
                      daywiseMonthDate
                        ? new Date(daywiseMonthDate + "-01")
                        : new Date()
                    }
                    view="year"
                    onClickMonth={(date) => handleDaywiseMonthChange(date)}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Comparison Summary */}
          <div
            className="d-flex gap-3"
            style={{ width: "250px", height: "32px" }}
          >
            <span
              style={{
                color: daywiseIsLow ? "#3D9D85" : "#fbb",
                fontSize: `${fontResize(30, fontPercentage)}px`,
                fontWeight: "700",
              }}
            >
              {daywisePercentage ?? "0"}%
            </span>
            <label
              style={{
                color: "#66737E",
                fontFamily: "Epilogue",
                fontWeight: "400",
                fontSize: `${fontResize(13, fontPercentage)}px`,
              }}
            >
              {daywiseIsLow ? "increased" : "decreased"} from last month
            </label>
          </div>

          {/* Chart */}
          <div style={{ width: "100%", overflowX: "auto" }}>
            {loadingDaywise ? (
              <div>Loading...</div>
            ) : errorDaywise ? (
              <div>{errorDaywise}</div>
            ) : (
              <BarChart
                data={daywiseData}
                barSize={12}
                width={700}
                height={220}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="day" />
                <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: "transparent" }}
                />
                <Bar dataKey="gatein" fill="#f66" radius={[10, 10, 0, 0]} />
                <Bar dataKey="dockin" fill="#fbb" radius={[10, 10, 0, 0]} />
              </BarChart>
            )}
          </div>
        </div>
      </Col>
    );
  };

  const dayWiseAverageDurationWidget = (fontPercentage) => {
    return (
      <Col sm={12} md={6} className="mt-3">
        <div className="chart_left col" style={{ height: "100%" }}>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ height: "36px" }}
          >
            <h3 style={{ fontSize: `${fontResize(16, fontPercentage)}px` }}>
              Day wise average duration{" "}
              <span
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#626F86",
                }}
              >
                (In mins)
              </span>
            </h3>
            <div
              onClick={() => setShowDayWiseAveragePicker(true)}
              style={{
                position: "relative",
                width: "146px",
                height: "36px",
                borderRadius: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
              }}
            >
              <div
                style={{
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  fontWeight: "500",
                  color: "#842234",
                }}
              >
                {formatDateCommon(dayWiseAverageMonth, "MMM, YYYY")} &nbsp;{" "}
                <img src={downArrow} alt="arrow" />
              </div>
              {showDayWiseAveragePicker && (
                <div
                  ref={dayWiseAveragePickerRef}
                  style={{
                    position: "absolute",
                    top: "40px",
                    right: "0",
                    zIndex: 100,
                    background: "#fff",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <Calendar
                    onChange={handleDayWiseAverageMonthChange}
                    value={dayWiseAverageMonth}
                    view="year"
                    onClickMonth={(date) =>
                      handleDayWiseAverageMonthChange(date)
                    }
                  />
                </div>
              )}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              overflowX: "auto",
              gap: "1rem",
              paddingBottom: "8px",
            }}
          >
            <div
              onClick={() => setSelectedDayWiseAverageType("gatein_out")}
              style={{
                flex: "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                height: "32px",
                borderRadius: "100px",
                padding: "8px",
                backgroundColor:
                  selectedDayWiseAverageType === "gatein_out"
                    ? "#d35258"
                    : "#f5f5f5",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  fontWeight: "500",
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  color:
                    selectedDayWiseAverageType === "gatein_out"
                      ? "#ffffff"
                      : "#172b4d",
                }}
              >
                Gate In
              </div>
              <div>
                <img
                  src={
                    selectedDayWiseAverageType === "gatein_out"
                      ? DashWhitearrow
                      : Dasharrow
                  }
                  alt="arrow"
                />
              </div>
              <div
                style={{
                  fontWeight: "500",
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  color:
                    selectedDayWiseAverageType === "gatein_out"
                      ? "#ffffff"
                      : "#172b4d",
                }}
              >
                Gate Out
              </div>
            </div>

            <div
              onClick={() => setSelectedDayWiseAverageType("gatein_dockin")}
              style={{
                flex: "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                height: "32px",
                borderRadius: "100px",
                padding: "8px",
                backgroundColor:
                  selectedDayWiseAverageType === "gatein_dockin"
                    ? "#d35258"
                    : "#f5f5f5",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  fontWeight: "500",
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  color:
                    selectedDayWiseAverageType === "gatein_dockin"
                      ? "#ffffff"
                      : "#172b4d",
                }}
              >
                Gate In
              </div>
              <div>
                <img
                  src={
                    selectedDayWiseAverageType === "gatein_dockin"
                      ? DashWhitearrow
                      : Dasharrow
                  }
                  alt="arrow"
                />
              </div>
              <div
                style={{
                  fontWeight: "500",
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  color:
                    selectedDayWiseAverageType === "gatein_dockin"
                      ? "#ffffff"
                      : "#172b4d",
                }}
              >
                Dock In
              </div>
            </div>

            <div
              onClick={() => setSelectedDayWiseAverageType("dockin_out")}
              style={{
                flex: "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                height: "32px",
                borderRadius: "100px",
                padding: "8px",
                backgroundColor:
                  selectedDayWiseAverageType === "dockin_out"
                    ? "#d35258"
                    : "#f5f5f5",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  fontWeight: "500",
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  color:
                    selectedDayWiseAverageType === "dockin_out"
                      ? "#ffffff"
                      : "#172b4d",
                }}
              >
                Dock In
              </div>
              <div>
                <img
                  src={
                    selectedDayWiseAverageType === "dockin_out"
                      ? DashWhitearrow
                      : Dasharrow
                  }
                  alt="arrow"
                />
              </div>
              <div
                style={{
                  fontWeight: "500",
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  color:
                    selectedDayWiseAverageType === "dockin_out"
                      ? "#ffffff"
                      : "#172b4d",
                }}
              >
                Out
              </div>
            </div>

            <div
              onClick={() => setSelectedDayWiseAverageType("dockout_gateout")}
              style={{
                flex: "none",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                height: "32px",
                borderRadius: "100px",
                padding: "8px",
                backgroundColor:
                  selectedDayWiseAverageType === "dockout_gateout"
                    ? "#d35258"
                    : "#f5f5f5",
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  fontWeight: "500",
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  color:
                    selectedDayWiseAverageType === "dockout_gateout"
                      ? "#ffffff"
                      : "#172b4d",
                }}
              >
                Dock Out
              </div>
              <div>
                <img
                  src={
                    selectedDayWiseAverageType === "dockout_gateout"
                      ? DashWhitearrow
                      : Dasharrow
                  }
                  alt="arrow"
                />
              </div>
              <div
                style={{
                  fontWeight: "500",
                  fontSize: `${fontResize(13, fontPercentage)}px`,
                  color:
                    selectedDayWiseAverageType === "dockout_gateout"
                      ? "#ffffff"
                      : "#172b4d",
                }}
              >
                Gate Out
              </div>
            </div>
          </div>

          <div style={{ width: "100%", overflowX: "auto" }}>
            <BarChart
              data={dayWiseAverageChartData ?? []}
              barSize={12}
              margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              width={700}
              height={220}
            >
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis
                dataKey="day"
                tickFormatter={(value) =>
                  value.length > 10 ? value.substring(0, 10) + "…" : value
                }
              />
              <Tooltip cursor={{ fill: "transparent" }} />
              <Bar dataKey="avg" fill="#f66" radius={[10, 10, 0, 0]} />
            </BarChart>
          </div>
        </div>
      </Col>
    );
  };
  const vehicleInOutWidget = (fontPercentage) => {
    return (
      <div
        style={{
          borderRadius: "16px",
          padding: "16px",
          backgroundColor: "#ffffff",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <Row>
          <Col sm={12}>
            <Row style={{ marginBottom: "16px" }}>
              <Col sm={12} md={6} lg={8} className="mb-3">
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: `${fontResize(16, fontPercentage)}px`,
                    color: "#172b4d",
                  }}
                >
                  Vehicles came in and out count
                </div>
              </Col>

              <Col
                sm={12}
                md={6}
                lg={4}
                className="mb-3"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "0px" }}
                >
                  <div className="style-justify-end">
                    <div className="vehicle-in-out-search-box me-2 flex items-center border rounded-md w-full md:w-auto">
                      <select
                        value={searchVehicleInOut}
                        onChange={(e) => {
                          setSearchVehicleInOut(e.target.value);
                        }}
                        style={{
                          flex: 1,
                          fontWeight: "500",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          color: "#D35258",
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <option value="department">Department</option>
                        <option value="vehicletype">Vehicle Type</option>
                        <option value="vendor">Vendor</option>
                        <option value="transporter">Transporter</option>
                        <option value="customer">Customer</option>
                      </select>
                      <div className="vehicle-in-out-search-text">
                        <span className="ms-1 icon mr-2">
                          <img
                            src={search}
                            alt="search"
                            className="search-icon w-4 h-4"
                          />
                        </span>
                        <input
                          ref={searchInputRef}
                          type="text"
                          placeholder="Search"
                          className="outline-none w-full"
                          style={{ outline: "none", border: "none" }}
                          onChange={handleSearch}
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <select
                      value={vehicleTransType}
                      onChange={(e) => {
                        setVehicleTransType(e.target.value);
                      }}
                      style={{
                        height: "36px",
                        border: "1px solid #ebebeb",
                        padding: "0px 16px",
                        backgroundColor: "#ffffff",
                        borderRadius: "12px",
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      <option value="in">Vehicle come in</option>
                      <option value="out">Vehicle come out</option>
                    </select>
                  </div>
                  <div
                    onClick={() => setShowVehicleMonthPicker(true)}
                    style={{
                      position: "relative",
                      width: "146px",
                      height: "36px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        fontWeight: "500",
                        color: "#842234",
                      }}
                    >
                      {formatDateCommon(
                        selectedVehicleMonth != null
                          ? selectedVehicleMonth
                          : undefined,
                        "MMM, YYYY"
                      )}{" "}
                      &nbsp; <img src={downArrow} />
                    </div>
                    {showVehicleMonthPicker && (
                      <div
                        ref={alertVehicleDateRef}
                        style={{
                          position: "absolute",
                          top: "40px",
                          right: "0",
                          zIndex: 100,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Calendar
                          onChange={handleVehicleMonthPickerChange}
                          value={selectedVehicleMonth}
                          view="year"
                          onClickMonth={(date) =>
                            handleVehicleMonthPickerChange(date)
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row>
              <Col sm={12} style={{ overflow: "scroll" }}>
                <div style={{ width: "fit-content" }}>
                  <div className="style-justify-start">
                    <div className="vehicle-root-box">
                      <select
                        value={selectedSideBar}
                        onChange={(e) => {
                          setSelectedSideBar(e.target.value);
                        }}
                        style={{
                          flex: 1,
                          width: "80px",
                          fontWeight: "500",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          color: "#D35258",
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <option value="department">Department</option>
                        <option value="vehicletype">Vehicle Type</option>
                        <option value="vendor">Vendor</option>
                        <option value="transporter">Transporter</option>
                        <option value="customer">Customer</option>
                      </select>{" "}
                      /
                      <select
                        value={selectedTopBar}
                        onChange={(e) => {
                          setSelectedTopBar(e.target.value);
                        }}
                        style={{
                          flex: 1,
                          width: "80px",
                          fontWeight: "500",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          color: "#D35258",
                          background: "transparent",
                          border: "none",
                        }}
                      >
                        <option value="department">Department</option>
                        <option value="vehicletype">Vehicle Type</option>
                        <option value="vendor">Vendor</option>
                        <option value="transporter">Transporter</option>
                        <option value="customer">Customer</option>
                      </select>
                    </div>
                    {vehicleInOutCount.length > 0 &&
                      vehicleInOutCount[0]?.map((title, index) => {
                        if (index !== 0) {
                          return <div className="heading-top-bar">{title}</div>;
                        } else {
                          return <div></div>;
                        }
                      })}
                  </div>
                  {/* {vehicleInOutCount.filter((_, index) => index !== 0).map((childArray, index) => (
                <div className="style-justify-start">
                    {childArray[index]?.map((childValue, index2) => 
                    {                      
                return (<div className={`${index2===0?'vehicle-root-box':'heading-top-bar'}`}>{childValue}</div>)
                    }
                    )}
                      </div> 
))} */}
                  {vehicleInOutCount.slice(1).map((row, rowIndex) => (
                    <div key={rowIndex} className="style-justify-start">
                      {row.map((cell, colIndex) => (
                        <div
                          key={"r" + rowIndex + colIndex}
                          className={`${
                            colIndex === 0
                              ? "vehicle-root-box"
                              : "heading-top-bar"
                          }`}
                        >
                          {cell}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );
  };
  const departmentWiseDockWidget = (fontPercentage) => {
    return (
      <div
        style={{
          borderRadius: "16px",
          padding: "16px",
          backgroundColor: "#ffffff",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        <Row>
          <Col sm={12}>
            <Row style={{ marginBottom: "16px" }}>
              <Col sm={12} md={6} lg={8} className="mb-3">
                <div
                  style={{
                    fontWeight: "700",
                    fontSize: `${fontResize(16, fontPercentage)}px`,
                    color: "#172b4d",
                  }}
                >
                  Department wise dock overview
                </div>
              </Col>

              <Col
                sm={12}
                md={6}
                lg={4}
                className="mb-3"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ display: "flex", alignItems: "center", gap: "0px" }}
                >
                  <div>
                    <select
                      value={selectedLocationId}
                      onChange={handleLocationChange}
                      style={{
                        height: "36px",
                        border: "1px solid #ebebeb",
                        padding: "0px 16px",
                        backgroundColor: "#ffffff",
                        borderRadius: "12px",
                        fontWeight: "600",
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        color: "#d35258",
                      }}
                    >
                      <option value="">Select Location</option>
                      {locations.map((loc) => (
                        <option key={loc.value} value={loc.value}>
                          {loc.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div
                    onClick={() => setShowDeptMonthPicker(true)}
                    style={{
                      position: "relative",
                      width: "146px",
                      height: "36px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <div
                      style={{
                        fontSize: `${fontResize(13, fontPercentage)}px`,
                        fontWeight: "500",
                        color: "#842234",
                      }}
                    >
                      {formatDateCommon(
                        selectedDeptMonth != null
                          ? selectedDeptMonth
                          : undefined,
                        "MMM, YYYY"
                      )}{" "}
                      &nbsp; <img src={downArrow} />
                    </div>
                    {showDeptMonthPicker && (
                      <div
                        ref={alertDeptDateRef}
                        style={{
                          position: "absolute",
                          top: "40px",
                          right: "0",
                          zIndex: 100,
                          background: "#fff",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
                        }}
                      >
                        <Calendar
                          onChange={handleDeptMonthPickerChange}
                          value={selectedDeptMonth}
                          view="year"
                          onClickMonth={(date) =>
                            handleDeptMonthPickerChange(date)
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            </Row>

            {departmentWiseData.map((dept, index) => (
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#f8f8f8",
                  marginBottom: "16px",
                }}
              >
                <Row>
                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: `${fontResize(16, fontPercentage)}px`,
                          color: "#d35258",
                        }}
                      >
                        {dept.name ?? ""}
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: `${fontResize(16, fontPercentage)}px`,
                          color: "#172b4d",
                        }}
                      >
                        {dept.docks ?? "0"}{" "}
                        <span
                          style={{
                            fontWeight: "400",
                            fontSize: `${fontResize(16, fontPercentage)}px`,
                            color: "#172b4d",
                          }}
                        >
                          docks
                        </span>
                      </div>
                    </div>
                  </Col>

                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          color: "#66737e",
                        }}
                      >
                        Utilization % by duration
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: `${fontResize(20, fontPercentage)}px`,
                          color: "#2c8c53",
                        }}
                      >
                        {dept.duration_util ?? "0"}%
                      </div>
                    </div>
                  </Col>

                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          color: "#66737e",
                        }}
                      >
                        Utilization % by vehicles
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: `${fontResize(20, fontPercentage)}px`,
                          color: "#2c8c53",
                        }}
                      >
                        {dept.vehicle_util ?? "0"}%
                      </div>
                    </div>
                  </Col>

                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        title="Avg. duration for Dock in to Dock out"
                        style={{
                          fontWeight: "500",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          color: "#66737e",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          width: "100%",
                        }}
                      >
                        Avg. duration for Dock in to Dock out
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: `${fontResize(20, fontPercentage)}px`,
                          color: "#d35258",
                        }}
                      >
                        {dept.avgduration ?? "0"}%
                      </div>
                    </div>
                  </Col>

                  <Col /* sm={12} md={6} lg={3} */ className="mb-3">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                        borderRight: "1px solid #eac7c9",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "500",
                          fontSize: `${fontResize(13, fontPercentage)}px`,
                          color: "#66737e",
                        }}
                      >
                        Vehicles count
                      </div>

                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: `${fontResize(20, fontPercentage)}px`,
                          color: "#d35258",
                        }}
                      >
                        {dept.vehicle ?? "0"}
                      </div>
                    </div>
                  </Col>
                  <div
                    onClick={() => {
                      setExpandIndex(expandIndex === index ? -1 : index);
                      if (expandIndex === -1) {
                        fetchDepartmentWiseDockData(dept.dept_id ?? 0);
                      }
                    }}
                    className="style-justify-center cursor-pointer"
                    style={{
                      width: "44px",
                      height: "44px",
                      borderRadius: "100px",
                      background: expandIndex === index ? "#D35258" : "#FFFFFF",
                    }}
                  >
                    <img
                      alt="arrow"
                      src={expandIndex === index ? arrowUp : arrowDown}
                    />
                  </div>
                </Row>
                {expandIndex === index && (
                  <div
                    className="table-container table-responsive"
                    style={{ borderRadius: "12px" }}
                  >
                    <table
                      className="dock-percentage-table"
                      style={{ width: "100%", borderCollapse: "collapse" }}
                    >
                      <thead>
                        <tr
                          style={{
                            fontSize: `${fontResize(14, fontPercentage)}px`,
                            fontWeight: "600",
                            color: "#172B4D",
                          }}
                        >
                          {/*  <th style={{ height: "44px", padding: "8px 8px" }}>  
                                <input type="checkbox" />
                              </th> */}
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Dock name
                          </th>
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Utilization % by duration
                          </th>
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Utilization % by vehicles
                          </th>
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Avg. duration for Dock in to Dock out
                          </th>
                          <th style={{ height: "47px", padding: "8px 8px" }}>
                            Vehicles count
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {departmentWiseDockData?.map((dockItem, index2) => (
                          <tr
                            key={"dock_table_" + index2}
                            style={{
                              backgroundColor: "#ffffff",
                              cursor: "pointer",
                              transition: "border-color 0.3s",
                            }}
                          >
                            {/* <td style={{ height: "44px", padding: "8px 8px" }}> 
                                <input type="checkbox" onClick={(e) => e.stopPropagation()} />
                                </td> */}
                            <td
                              className="overflow-hidden"
                              style={{
                                height: "44px",
                                width: "150px",
                                maxWidth: "200px",
                                padding: "8px 8px",
                                fontSize: `${fontResize(14, fontPercentage)}px`,
                                fontWeight: "500",
                                color: "#172B4D",
                              }}
                            >
                              {dockItem.name ?? ""}
                            </td>
                            <td
                              className="overflow-hidden"
                              style={{
                                height: "44px",
                                width: "200px",
                                maxWidth: "250px",
                                padding: "8px 8px",
                                fontSize: `${fontResize(16, fontPercentage)}px`,
                                fontWeight: "600",
                                color: "#2C8C53",
                              }}
                            >
                              {dockItem.duration_util ?? "0"}%
                            </td>
                            <td
                              style={{
                                height: "44px",
                                width: "150px",
                                padding: "8px 8px",
                                fontSize: `${fontResize(16, fontPercentage)}px`,
                                fontWeight: "600",
                                color: "#2C8C53",
                              }}
                            >
                              {dockItem.vehicle_util ?? "0"}%
                            </td>
                            <td
                              className="overflow-hidden"
                              style={{
                                height: "44px",
                                width: "200px",
                                padding: "8px 8px",
                                fontSize: `${fontResize(16, fontPercentage)}px`,
                                fontWeight: "600",
                                color: "#D35258",
                              }}
                            >
                              {dockItem.avgduration ?? ""}
                            </td>
                            <td
                              className="overflow-hidden"
                              style={{
                                height: "44px",
                                width: "150px",
                                padding: "8px 8px",
                                fontSize: `${fontResize(16, fontPercentage)}px`,
                                fontWeight: "600",
                                color: "#D35258",
                              }}
                            >
                              {dockItem.vehicle ?? ""}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </Col>
        </Row>
      </div>
    );
  };
  const customFontPercentage = (width, width_size) => {
    if (width === "custom") return width_size ?? 0;
    if (width === "large") return 30;
    if (width === "medium") return 0;
    if (width === "small") return -20;
    return 0;
  };

  const liveMonitorWidget = (fontPercentage) => {
    return (
      <>
        <div
          className="live_head"
          style={{ fontSize: `${fontResize(20, fontPercentage)}px` }}
        >
          Live moniter
        </div>
        <Row className="live_contain row d-flex">
          {/* Loading Section */}
          <Col sm={12} md={6} lg={4} className="mt-3">
            <div className="live_boxses col">
              <div className="d-flex gap-1">
                <div
                  style={{
                    height: "12px",
                    width: "12px",
                    borderRadius: "50px",
                    backgroundColor: "#5FD991",
                    marginTop: "3px",
                  }}
                ></div>
                <div
                  className="live_text"
                  style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                >
                  Ontime
                </div>
              </div>
              <div
                style={{
                  height: "425px",
                  overflow: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {liveMonitorList
                  ?.filter((item) => item.current_status === "ontime")
                  .map((detail, index) => (
                    <div
                      key={"ontime" + index}
                      className="live_box mt-3"
                      style={{
                        position: "relative",
                        backgroundColor: "#DBFFEA",
                      }}
                    >
                      <div>
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ height: "28px" }}
                        >
                          <div className="style-justify-start">
                            <div
                              style={{
                                fontSize: `${fontResize(15, fontPercentage)}px`,
                                fontWeight: "700",
                                color: "#172B4D",
                              }}
                            >
                              {detail.vehicle_number}
                            </div>
                            <div className="dot-box mx-3"></div>
                            {detail.dock_type === "load_in" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#2C8C53",
                                  fontSize: `${fontResize(
                                    11,
                                    fontPercentage
                                  )}px`,
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Loading
                              </div>
                            )}
                            {detail.dock_type === "load_out" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#6929E2",
                                  fontSize: `${fontResize(
                                    11,
                                    fontPercentage
                                  )}px`,
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Unloading
                              </div>
                            )}
                          </div>
                          <div className="box_btn">Ontime</div>
                        </div>
                        <div className="d-flex align-items-center">
                          <label
                            className="box_label1"
                            style={{
                              fontSize: `${fontResize(11, fontPercentage)}px`,
                            }}
                          >
                            Est. Time :{" "}
                          </label>
                          <label
                            className="box_label2 ps-2"
                            style={{
                              fontSize: `${fontResize(13, fontPercentage)}px`,
                            }}
                          >
                            {detail.estimated_time}
                          </label>
                        </div>
                        <div className="d-flex mt-2 gap-2">
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Dock in Time
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                              }}
                            >
                              {detail.dock_in_time}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "3px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Dock Number
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                              }}
                            >
                              {detail.display_name}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "2px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Timer
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                              }}
                            >
                              <Timer
                                key={"ontime_timer" + index}
                                initialSeconds={parseDuration(detail.duration)}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="live_box_border"
                        style={{
                          position: "absolute",
                          left: "12px",
                          bottom: "0",
                        }}
                      ></div>
                    </div>
                  ))}
              </div>
            </div>
          </Col>

          {/* Delay Section */}
          <Col sm={12} md={6} lg={4} className="mt-3">
            <div className="live_boxses col">
              <div className="d-flex gap-1">
                <div
                  style={{
                    height: "12px",
                    width: "12px",
                    borderRadius: "50px",
                    backgroundColor: "#FFC267",
                    marginTop: "3px",
                  }}
                ></div>
                <div
                  className="live_text"
                  style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                >
                  Delay
                </div>
              </div>
              <div
                style={{
                  height: "425px",
                  overflow: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {liveMonitorList
                  ?.filter((item) => item.current_status === "delay")
                  .map((detail, index) => (
                    <div
                      key={"delay" + index}
                      className="live_box mt-3"
                      style={{
                        position: "relative",
                        backgroundColor: "#FFF1DD",
                      }}
                    >
                      <div>
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ height: "28px" }}
                        >
                          <div className="style-justify-start">
                            <div
                              style={{
                                fontSize: `${fontResize(15, fontPercentage)}px`,
                                fontWeight: "700",
                                color: "#172B4D",
                              }}
                            >
                              {detail.vehicle_number}
                            </div>
                            <div className="dot-box mx-3"></div>
                            {detail.dock_type === "load_in" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#2C8C53",
                                  fontSize: `${fontResize(
                                    11,
                                    fontPercentage
                                  )}px`,
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Loading
                              </div>
                            )}
                            {detail.dock_type === "load_out" && (
                              <div
                                className="style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#6929E2",
                                  fontSize: `${fontResize(
                                    11,
                                    fontPercentage
                                  )}px`,
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Unloading
                              </div>
                            )}
                          </div>
                          <div className="box_btn" style={{ color: "#FFC267" }}>
                            Delay
                          </div>
                        </div>
                        <div className="d-flex align-items-center">
                          <label
                            className="box_label1"
                            style={{
                              fontSize: `${fontResize(11, fontPercentage)}px`,
                            }}
                          >
                            Est. Time :{" "}
                          </label>
                          <label
                            className="box_label2 ps-2"
                            style={{
                              fontSize: `${fontResize(13, fontPercentage)}px`,
                            }}
                          >
                            {detail.estimated_time}
                          </label>
                        </div>
                        <div className="d-flex mt-2 gap-2">
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Dock in Time
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                              }}
                            >
                              {detail.dock_in_time}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "3px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Dock number
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                              }}
                            >
                              {detail.display_name}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "2px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Timer
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                color: "#FFC267",
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                              }}
                            >
                              <Timer
                                key={"delay_timer" + index}
                                initialSeconds={parseDuration(detail.duration)}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="live_box_border"
                        style={{
                          position: "absolute",
                          left: "12px",
                          bottom: "0",
                          backgroundColor: "#FFC267",
                        }}
                      ></div>
                    </div>
                  ))}
              </div>
            </div>
          </Col>

          {/* Over-Delay Section */}
          <Col sm={12} md={6} lg={4} className="mt-3">
            <div className="live_boxses col">
              <div className="d-flex gap-1">
                <div
                  style={{
                    height: "12px",
                    width: "12px",
                    borderRadius: "50px",
                    backgroundColor: "#FE8B90",
                    marginTop: "3px",
                  }}
                ></div>
                <div
                  className="live_text"
                  style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}
                >
                  Over-Delay
                </div>
              </div>
              <div
                style={{
                  height: "425px",
                  overflow: "auto",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                {liveMonitorList
                  ?.filter((item) => item.current_status === "overdelay")
                  .map((detail, index) => (
                    <div
                      key={"overdelay" + index}
                      className="live_box mt-3"
                      style={{
                        position: "relative",
                        backgroundColor: "#FFEAEB",
                      }}
                    >
                      <div>
                        <div
                          className="d-flex align-items-center justify-content-between"
                          style={{ height: "28px" }}
                        >
                          <div className="style-justify-start">
                            <div
                              style={{
                                fontSize: `${fontResize(15, fontPercentage)}px`,
                                fontWeight: "700",
                                color: "#172B4D",
                              }}
                            >
                              {detail.vehicle_number}
                            </div>
                            <div className="dot-box mx-3"></div>
                            {detail.dock_type === "load_in" && (
                              <div
                                className="d-flex align-item-center style-justify-center  px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#2C8C53",
                                  fontSize: `${fontResize(
                                    11,
                                    fontPercentage
                                  )}px`,
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Loading
                              </div>
                            )}
                            {detail.dock_type === "load_out" && (
                              <div
                                className="d-flex align-item-center  style-justify-center px-2 py-1"
                                style={{
                                  borderRadius: "100px",
                                  background: "#6929E2",
                                  fontSize: `${fontResize(
                                    11,
                                    fontPercentage
                                  )}px`,
                                  fontWeight: "600",
                                  color: "#FFFFFF",
                                }}
                              >
                                Unloading
                              </div>
                            )}
                          </div>
                          <div className="box_btn" style={{ color: "#FE8B90" }}>
                            Over Delay
                          </div>
                        </div>
                        <div className="d-flex align-items-center pt-1">
                          <label
                            className="box_label1"
                            style={{
                              fontSize: `${fontResize(11, fontPercentage)}px`,
                            }}
                          >
                            Est. Time :{" "}
                          </label>
                          <label
                            className="box_label2 ps-2"
                            style={{
                              fontSize: `${fontResize(13, fontPercentage)}px`,
                            }}
                          >
                            {detail.estimated_time}
                          </label>
                        </div>
                        <div className="d-flex mt-2 gap-2">
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Dock in Time
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                              }}
                            >
                              {detail.dock_in_time}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "3px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Dock number
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                              }}
                            >
                              {detail.display_name}
                            </label>
                          </div>
                          <div
                            style={{
                              width: "2px",
                              height: "38px",
                              backgroundColor: "#E5E5E5",
                              marginLeft: "10px",
                            }}
                          ></div>
                          <div className="d-flex flex-column">
                            <label
                              className="box_label1"
                              style={{
                                fontSize: `${fontResize(11, fontPercentage)}px`,
                              }}
                            >
                              Timer
                            </label>
                            <label
                              className="box_label2"
                              style={{
                                fontSize: `${fontResize(13, fontPercentage)}px`,
                                color: "#FE8B90",
                              }}
                            >
                              <Timer
                                key={"overdelay_timer" + index}
                                initialSeconds={parseDuration(detail.duration)}
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div
                        className="live_box_border"
                        style={{
                          position: "absolute",
                          left: "12px",
                          bottom: "0",
                          backgroundColor: "#FE8B90",
                        }}
                      ></div>
                    </div>
                  ))}
              </div>
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const widgetRenderers = {
    "Dock status list": dockStatusWidget,
    "Live count": liveCountWidget,
    "History count": historyCountWidget,
    "Location based dock in and out": locationDockInOutWidget,
    "Location based free docks": locationFreeDocksWidget,
    "Average duration": averageDurationWidget,
    Timings: timingsWidget,
    "Day wise gate and dock in": dayWiseGateDockInWidget,
    "Day wise average duration": dayWiseAverageDurationWidget,
    "Vehicle came in and out": vehicleInOutWidget,
    "Department wise dock overview": departmentWiseDockWidget,
    "Live monitor": liveMonitorWidget,
  };

  return (
    <div className="content_container">
      {/* box contain */}
      <Row className="row d-flex">
        {sortedWidgetList?.map((widget, i) => {
          if (!widget.status) return null;

          const fontPercentage = customFontPercentage(
            widget.width,
            widget.width_size
          );
          const renderer = widgetRenderers[widget.name];

          return renderer ? renderer(fontPercentage) : null;
        })}
      </Row>

      {/* chart contain */}
      {/*  <Row className="row d-flex">
       
        
      </Row> */}

      {/*  <Row style={{ marginTop: "16px", marginBottom: "16px" }} className="d-flex">
       
       
      </Row> */}

      {/*  <Row className="row d-flex" style={{ alignItems: "stretch", marginBottom: '16px' }}>
        
        


      </Row> */}

      <div
        style={{
          textAlign: "center",
          marginTop: "80px",
          fontWeight: "400",
          fontSize: "12px",
          color: "#172B4D",
        }}
      >
        Powered by{" "}
        <span>
          <img src={mawalog} />
        </span>
      </div>
    </div>
  );
};

export default DockWebDashboard;

const Timer = ({ displayName, initialSeconds, fontPercentage = 0 }) => {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    /* if (secondsLeft <= 0) return; */

    const timerId = setInterval(() => {
      setSecondsLeft((prev) => (prev > 0 ? prev + 1 : 0));
    }, 1000);

    return () => clearInterval(timerId);
  }, [secondsLeft]);

  return (
    <div /* style={{ marginBottom: "10px" }} */>
      <span style={{ fontSize: `${fontResize(14, fontPercentage)}px` }}>
        {formatDuration(secondsLeft)}
      </span>
    </div>
  );
};
const fontResize = (baseFont, percentage) => {
  const fontSize = baseFont * (1 + percentage / 100);
  return fontSize;
};
const formatDuration = (totalSeconds) => {
  const h = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
  const s = String(totalSeconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const parseDuration = (timeStr) => {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};
